import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import CampaignTutorialStep from './CampaignTutorialStep';

import { t } from 'utils/language';
import { sanitizeGenericHtml } from 'utils/sanitize';

type Step = {
  name: string
};

type Props = {
  activeStep: string,
  steps: Array<Step>
};

class CampaignTutorial extends React.PureComponent<Props> {
  renderSteps(steps: Array<Step>, activeStep: string): React.ReactNode {
    return (
      <React.Fragment>
        {
          steps.map((step, index) => {
            const isActive = step.name === activeStep;
            const className = classnames({
              'campaign-tutorial__step': true,
              'campaign-tutorial__step--active': isActive
            });

            return (
              <CampaignTutorialStep
                key={step.name}
                stepIndex={index + 1}
                active={isActive}
                className={className}
                title={t(`campaign_tutorial.step_${step.name}_title`)}
                message={t(`campaign_tutorial.step_${step.name}_message`)}
              />
            );
          })
        }
      </React.Fragment>
    );
  }
  render() {
    const { steps, activeStep } = this.props;

    return (
      <section className="campaign-tutorial">
        <div className="campaign-tutorial__title">
          <div className="campaign-tutorial__icon">
            <SVGDynamicIcon
              name="info-inside-circle-custom-bg"
              width={24}
              height={24}
              customColor="blue"
            />
          </div>
          <div>
            {t('campaign_tutorial.title')}
          </div>
        </div>
        {this.renderSteps(steps, activeStep)}
        <div
          className="campaign-tutorial__more"
          dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(t('campaign_tutorial.additional_info')) }}
        />
      </section>
    );
  }
}

export default CampaignTutorial;
